import ResourceApi from "@/src/modules/core/api/resource-api";

import type {AmenityAccessLog} from "../types";

export function createAmenityAccessLogApi(accessLogPath: string) {
  return new ResourceApi<AmenityAccessLog>(accessLogPath);
}
